// import { Component } from '@angular/core';
// import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
// import { environment } from '../../environments/environment.prod';
// import { FormsModule } from '@angular/forms';

// declare var Razorpay: any;

// @Component({
//   selector: 'app-patient-subscription',
//   templateUrl: './patient-subscription.component.html',
//   styleUrls: ['./patient-subscription.component.css']
// })
// export class PatientSubscriptionComponent {
//   showPopup = false;
//   popupStep = 1;
//   selectedPlan: any = null;
//   userData = { name: '', phone: '', otp: '' };
//   isLoading: boolean = false;
//   backendOrderId: string = '';

//   plans = [
//     { 
//       name: 'Monthly', 
//       price: 69, 
//       originalPrice: 99, 
//       duration: 'mo', 
//       featured: false,
//       totalApps: 60, 
//       unitPrice: '1.15', 
//       bought: 84, 
//       features: [
//         { text: '1-Day Advance Token Booking', active: true },
//         { text: 'Morning Token Generation', active: true },
//         { text: 'Live Digital Queue Tracking', active: true },
//         { text: 'Medicine Discounts', active: false },
//         { text: 'Lab Discounts', active: false }
//       ]
//     },
//     { 
//       name: 'Half Yearly', 
//       price: 354, 
//       originalPrice: 708, 
//       duration: '6mo', 
//       featured: true,
//       totalApps: 400, 
//       unitPrice: '0.88', 
//       bought: 156, 
//       features: [
//         { text: '1-Day Advance Token Booking', active: true },
//         { text: 'Morning Token Generation', active: true },
//         { text: 'Live Digital Queue Tracking', active: true },
//         { text: '15% Off Medicines', active: true },
//         { text: '25% Off Labs', active: true }
//       ]
//     },
//     { 
//       name: 'Yearly', 
//       price: 499, 
//       originalPrice: 999, 
//       duration: 'yr', 
//       featured: false,
//       totalApps: 1000, 
//       unitPrice: '0.50', 
//       bought: 29, 
//       features: [
//         { text: '1-Day Advance Token Booking', active: true },
//         { text: 'Morning Token Generation', active: true },
//         { text: 'Live Digital Queue Tracking', active: true },
//         { text: '20% Off Medicines', active: true },
//         { text: '40% Off Labs', active: true }
//       ]
//     }
//   ];

//   constructor(private authService: AuthService) {}

//   openPopup(plan: any) {
//     this.selectedPlan = plan;
//     this.showPopup = true;
//     this.popupStep = 1;
//   }

//   closePopup() { 
//     this.showPopup = false; 
//     this.userData = { name: '', phone: '', otp: '' };
//     this.backendOrderId = '';
//   }

//   onlyNumbersAllowed(event: KeyboardEvent): boolean {
//     const charCode = event.which ? event.which : event.keyCode;
//     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
//       event.preventDefault();
//       return false;
//     }
//     return true;
//   }

//   nextStep() {
//     // STEP 1: Handle Login / Request OTP
//     if (this.popupStep === 1) {
//       const cleanPhoneStr = this.userData.phone ? this.userData.phone.toString().trim() : '';

//       if (!cleanPhoneStr || cleanPhoneStr.length < 10) {
//         alert('Please enter a valid 10-digit mobile number');
//         return;
//       }
      
//       const phoneNo = Number(cleanPhoneStr);
//       if (isNaN(phoneNo)) {
//         alert('Mobile number must contain digits only');
//         return;
//       }
      
//       const patientName = this.userData.name || '.';
//       this.isLoading = true;

//       this.authService.subscriptionLoginOtp(phoneNo, patientName).subscribe({
//         next: (response: any) => {
//           this.isLoading = false;
//           console.log('OTP Sent Successfully', response);
//           this.popupStep = 2; 
//         },
//         error: (err) => {
//           this.isLoading = false;
//           console.error('Login Error', err);
//           alert(err.error?.message || 'Something went wrong. Please try again.');
//         }
//       });
//     } 
//     // STEP 2: Verify OTP and fetch Order ID
//     else if (this.popupStep === 2) {
//       const cleanOtpStr = this.userData.otp ? this.userData.otp.toString().trim() : '';

//       if (!cleanOtpStr || cleanOtpStr.length < 4) {
//         alert('Please enter the complete 4-digit OTP code');
//         return;
//       }

//       const otpNumber = Number(cleanOtpStr);
//       const phoneNo = Number(this.userData.phone);
//       const patientName = this.userData.name || '.';

//       if (isNaN(otpNumber)) {
//         alert('OTP must contain numbers only');
//         return;
//       }

//       this.isLoading = true;

//       this.authService.authenticateOTP(otpNumber, phoneNo, patientName).subscribe({
//         next: (response: any) => {
//           console.log('OTP Verified Successfully!', response);
//           this.verifyOtpAndPrepareOrder();
//         },
//         error: (err) => {
//           this.isLoading = false;
//           console.error('OTP Verification Failure', err);
//           alert(err.error?.message || 'Invalid verification code. Please check and try again.');
//         }
//       });
//     }
//     else if (this.popupStep < 4) {
//       this.popupStep++;
//     }
//   }

//   verifyOtpAndPrepareOrder() {
//     this.isLoading = true;
//     // Replace with actual API endpoint layout when backend is configured
//     setTimeout(() => {
//       this.backendOrderId = 'order_MOCK_XYZ987654'; 
//       this.isLoading = false;
//       this.popupStep = 3; 
//     }, 1500);
//   }

//   payWithRazorpay() {
//     if (!this.backendOrderId) {
//       alert('Transaction initialization failed. Please try again.');
//       return;
//     }

//     const options = {
//       key: environment.razorpayKeyId, 
//       amount: this.selectedPlan.price * 100, 
//       currency: 'INR',
//       name: 'DOQMA',
//       description: `Purchase: ${this.selectedPlan.name}`,
//       image: '../../../assets/logo.png', 
//       order_id: this.backendOrderId,
//       prefill: {
//         name: this.userData.name,
//         contact: this.userData.phone
//       },
//       theme: {
//         color: '#5bc5c5' 
//       },
//       handler: (response: any) => {
//         this.handlePaymentSuccess(response);
//       },
//       modal: {
//         ondismiss: () => {
//           console.log('Payment modal exited prematurely by user action.');
//         }
//       }
//     };

//     const rzp = new Razorpay(options);
//     rzp.open();
//   }

//   handlePaymentSuccess(paymentMetadata: any) {
//     this.isLoading = true;
//     setTimeout(() => {
//       this.isLoading = false;
//       this.popupStep = 4; 
//     }, 1000);
//   }
// }


//  new code for 
// import { Component,NgZone } from '@angular/core';
// import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
// import { environment } from '../../environments/environment.prod';
// import { FormsModule } from '@angular/forms';

// declare var Razorpay: any;

// @Component({
//   selector: 'app-patient-subscription',
//   templateUrl: './patient-subscription.component.html',
//   styleUrls: ['./patient-subscription.component.css']
// })
// export class PatientSubscriptionComponent {
//   showPopup = false;
//   popupStep = 1;
//   selectedPlan: any = null;
//   userData = { name: '', phone: '', otp: '' };
//   isLoading: boolean = false;
//   backendOrderId: string = '';
//   token:string='';

//   plans = [
//     { 
//       name: 'Monthly', 
//       price: 1, 
//       originalPrice: 2, 
//       duration: 'mo', 
//       featured: false,
//       totalApps: 60, 
//       unitPrice: '1.15', 
//       bought: 84, 
//       features: [
//         { text: '1-Day Advance Token Booking', active: true },
//         { text: 'Morning Token Generation', active: true },
//         { text: 'Live Digital Queue Tracking', active: true },
//         { text: 'Medicine Discounts', active: false },
//         { text: 'Lab Discounts', active: false }
//       ]
//     },
//     { 
//       name: 'Half Yearly', 
//       price: 354, 
//       originalPrice: 708, 
//       duration: '6mo', 
//       featured: true,
//       totalApps: 400, 
//       unitPrice: '0.88', 
//       bought: 156, 
//       features: [
//         { text: '1-Day Advance Token Booking', active: true },
//         { text: 'Morning Token Generation', active: true },
//         { text: 'Live Digital Queue Tracking', active: true },
//         { text: '15% Off Medicines', active: true },
//         { text: '25% Off Labs', active: true }
//       ]
//     },
//     { 
//       name: 'Yearly', 
//       price: 499, 
//       originalPrice: 999, 
//       duration: 'yr', 
//       featured: false,
//       totalApps: 1000, 
//       unitPrice: '0.50', 
//       bought: 29, 
//       features: [
//         { text: '1-Day Advance Token Booking', active: true },
//         { text: 'Morning Token Generation', active: true },
//         { text: 'Live Digital Queue Tracking', active: true },
//         { text: '20% Off Medicines', active: true },
//         { text: '40% Off Labs', active: true }
//       ]
//     }
//   ];

//   constructor(private authService: AuthService,private ngZone: NgZone) {}

//   openPopup(plan: any) {
//     this.selectedPlan = plan;
//     this.showPopup = true;
//     this.popupStep = 1;
//   }

//   closePopup() { 
//     this.showPopup = false; 
//     this.userData = { name: '', phone: '', otp: '' };
//     this.backendOrderId = '';
//     this.isLoading = false;
//   }

//   onlyNumbersAllowed(event: KeyboardEvent): boolean {
//     const charCode = event.which ? event.which : event.keyCode;
//     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
//       event.preventDefault();
//       return false;
//     }
//     return true;
//   }

//   // ================= UNIFIED STEP CONTROL (Matches HTML click listeners) =================
//   nextStep() {
//     // STEP 1: Handle Login / Request OTP Delivery
//     if (this.popupStep === 1) {
//       const cleanPhoneStr = this.userData.phone ? this.userData.phone.toString().trim() : '';

//       if (!cleanPhoneStr || cleanPhoneStr.length !== 10) {
//         alert('Please enter a valid 10-digit mobile number');
//         return;
//       }
      
//       const phoneNo = Number(cleanPhoneStr);
//       if (isNaN(phoneNo)) {
//         alert('Mobile number must contain digits only');
//         return;
//       }
      
//       const patientName = this.userData.name || '.';
//       this.isLoading = true;

//       this.authService.subscriptionLoginOtp(phoneNo, patientName).subscribe({
//         next: (response: any) => {
//           this.isLoading = false;
//           console.log('OTP Sent Successfully', response);
//           this.popupStep = 2; // Route interface layout smoothly to screen 2
//         },
//         error: (err) => {
//           this.isLoading = false;
//           console.error('Login Error', err);
//           alert(err.error?.message || 'Something went wrong. Please try again.');
//         }
//       });
//     } 
    
//     // STEP 2: Validate Input Token & Request Razorpay Order ID context
//     else if (this.popupStep === 2) {
//       const cleanOtpStr = this.userData.otp ? this.userData.otp.toString().trim() : '';

//       if (!cleanOtpStr || cleanOtpStr.length !== 4) {
//         alert('Please enter the complete 4-digit OTP code');
//         return;
//       }

//       const otpNumber = Number(cleanOtpStr);
//       const phoneNo = Number(this.userData.phone);
//       const patientName = this.userData.name || '.';

//       if (isNaN(otpNumber)) {
//         alert('OTP must contain numbers only');
//         return;
//       }

//       this.isLoading = true;

//       this.authService.authenticateOTP(otpNumber, phoneNo, patientName).subscribe({
//         next: (response: any) => {
//           console.log('OTP Verified Successfully!', response);
//           let token = response.token
//           // Transition directly to creating the secure live payment transaction token
//           this.generatePaymentOrder(token);
//         },
//         error: (err) => {
//           this.isLoading = false;
//           console.error('OTP Verification Failure', err);
//           alert(err.error?.message || 'Invalid verification code. Please check and try again.');
//         }
//       });
//     }
    
//     // Fallback incremental step router for higher layout tiers if triggered
//     else if (this.popupStep < 4) {
//       this.popupStep++;
//     }
//   }

//   // ================= SECURE BACKEND INTERFACE ROUTE =================
//   // ================= SECURE BACKEND INTERFACE ROUTE =================
//   generatePaymentOrder(token:any) {
//     this.isLoading = true;
//     this.token=token;
//     // Updated payload matching the exact keys expected by the API: {duration, phone, name}
//     const orderPayload = {
//       duration: this.selectedPlan.duration, // Sends 'mo', '6mo', or 'yr'
//       phone: this.userData.phone,
//       name: this.userData.name || '.',
//       token:this.token
//     };

//     // Communicates with your staging/production endpoint to initialize order mapping tracking
//     this.authService.patientSubscriptionOrderCreate(orderPayload).subscribe({
//       next: (response: any) => {
//         this.isLoading = false;
//         if (response && response.orderId) {
//           this.backendOrderId = response.orderId;
//           this.popupStep = 3; // Shift directly to Step 3 layout (Confirm & Activate Screen)
//         } else {
//           alert('Failed to get a valid transactional token context from the server.');
//         }
//       },
//       error: (err) => {
//         this.isLoading = false;
//         console.error('Order Creation Error', err);
//         alert(err.error?.message || 'Error initializing secure payment order.');
//       }
//     });
//   }

//   // ================= STEP 3: NATIVE CHECKOUT GATEWAY TRIGGER =================
//   payWithRazorpay() {
//     if (!this.backendOrderId) {
//       alert('Transaction context missing or expired. Please verify your credentials again.');
//       this.popupStep = 1;
//       return;
//     }

//     const options = {
//       key: environment.razorpayKeyId, 
//       amount: this.selectedPlan.price * 100, // Converts amount parameter to paisa
//       currency: 'INR',
//       name: 'DOQMA',
//       description: `Purchase: ${this.selectedPlan.name}`,
//       image: '../../../assets/logo.png', 
//       order_id: this.backendOrderId,
//       prefill: {
//         name: this.userData.name,
//         contact: this.userData.phone
//       },
//       theme: {
//         color: '#5bc5c5' 
//       },
//       handler: (response: any) => {
//         this.handlePaymentSuccess(response);
//       },
//       modal: {
//         ondismiss: () => {
//           console.log('Payment modal exited prematurely by user action.');
//         }
//       }
//     };

//     const rzp = new Razorpay(options);
//     rzp.open();
//   }

//   // ================= STEP 4: SUCCESS SUMMARY DRAWER =================

//   handlePaymentSuccess(paymentMetadata: any) {
//     this.isLoading = true;
    
//     // Package verification footprint matching server database parameters
//     const verificationPayload = {
//       razorpayOrderId: paymentMetadata.razorpay_order_id,
//       razorpayPaymentId: paymentMetadata.razorpay_payment_id,
//       razorpaySignature: paymentMetadata.razorpay_signature,
//       duration: this.selectedPlan.duration,
//       phone: this.userData.phone,
//       token:this.token
//     };
//     console.log("HANDLE SUCCESS",verificationPayload);
//     // Make an API call to verify signature and update patient account subscription state
//     this.authService.verifySubscriptionPayment(verificationPayload).subscribe({
//       next: (serverVerificationResponse: any) => {

//         this.ngZone.run(()=>{
//    this.isLoading = false;
//         this.popupStep = 4; // Safely shift layout to Checkmark Screen once DB updates
//         console.log('Subscription fully activated on server:', serverVerificationResponse);
//         })
//       },
//       error: (err:any) => {
//         this.isLoading = false;
//         console.error('Payment Verification Failed inside backend context:', err);
//         alert(err.error?.message || 'Payment received, but verification failed. Please contact support.');
//       }
//     });
//   }
// }


import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { environment } from '../../environments/environment.prod';
import { timer, of } from 'rxjs';
import { switchMap, catchError, filter, take, timeout, map } from 'rxjs/operators';

declare var Razorpay: any;

@Component({
  selector: 'app-patient-subscription',
  templateUrl: './patient-subscription.component.html',
  styleUrls: ['./patient-subscription.component.css']
})
export class PatientSubscriptionComponent implements OnInit {
  showPopup = false;
  popupStep = 1;
  selectedPlan: any = null;
  userData = { name: '', phone: '', otp: '' };
  isLoading: boolean = false;
  backendOrderId: string = '';
  token: string = '';
  ssoToken: string | null = null;
  isSsoVerified: boolean = false;
  finalSuccessLoading:boolean =false;

  plans = [
    { 
      name: 'Monthly', 
      price: 1, 
      originalPrice: 2, 
      duration: 'mo', 
      featured: false,
      totalApps: 60, 
      unitPrice: '1.15', 
      bought: 84, 
      features: [
        { text: '1-Day Advance Token Booking', active: true },
        { text: 'Morning Token Generation', active: true },
        { text: 'Live Digital Queue Tracking', active: true },
        { text: 'Medicine Discounts', active: false },
        { text: 'Lab Discounts', active: false }
      ]
    },
    { 
      name: 'Half Yearly', 
      price: 354, 
      originalPrice: 708, 
      duration: '6mo', 
      featured: true,
      totalApps: 400, 
      unitPrice: '0.88', 
      bought: 156, 
      features: [
        { text: '1-Day Advance Token Booking', active: true },
        { text: 'Morning Token Generation', active: true },
        { text: 'Live Digital Queue Tracking', active: true },
        { text: '15% Off Medicines', active: true },
        { text: '25% Off Labs', active: true }
      ]
    },
    { 
      name: 'Yearly', 
      price: 499, 
      originalPrice: 999, 
      duration: 'yr', 
      featured: false,
      totalApps: 1000, 
      unitPrice: '0.50', 
      bought: 29, 
      features: [
        { text: '1-Day Advance Token Booking', active: true },
        { text: 'Morning Token Generation', active: true },
        { text: 'Live Digital Queue Tracking', active: true },
        { text: '20% Off Medicines', active: true },
        { text: '40% Off Labs', active: true }
      ]
    }
  ];

  constructor(
    private authService: AuthService,
    private ngZone: NgZone,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Check URL parameters for sso_token on page load
    this.route.queryParams.subscribe(params => {
      this.ssoToken = params['sso_token'] || params['sso token'] || params['ssoToken'] || null;

      // Scenario 1: Redirected from Mobile App with SSO token
      if (this.ssoToken) {
        this.verifyAndProcessSsoToken(this.ssoToken);
      }
      // Scenario 2: Directly opened in browser (No action needed, default OTP flow will apply)
    });
  }

  // SCENARIO 1: Verifies SSO token with backend and stores session details
  verifyAndProcessSsoToken(ssoToken: string): void {
    this.isLoading = true;
    this.authService.verifySsoToken(ssoToken).subscribe({
      next: (response: any) => {
        alert(response.user?.phone);
        this.isLoading = false;
        if (response && response.success) {
          this.isSsoVerified = true;
          this.token = response.token || '';
          this.userData.phone = response.user?.phone || '';
          this.userData.name = response.user?.name || '';
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.isSsoVerified = false;
        console.error('SSO Token Verification Failed:', err);
      }
    });
  }

  // openPopup(plan: any) {
  //   this.selectedPlan = plan;
  //   this.showPopup = true;

  //   // Scenario 1: Mobile App Redirect (SSO Token Verified) -> Skip Steps 1 & 2 directly to Step 3
  //   if (this.isSsoVerified && this.token) {
  //     this.generatePaymentOrder(this.token);
  //   } 
  //   // Scenario 2: Direct Open -> Start at Step 1 (Phone & Name Entry)
  //   else {
  //     this.popupStep = 1;
  //   }
  // }

  //  New openpopup

  openPopup(plan: any) {
  this.selectedPlan = plan;
  this.showPopup = true;

  // If SSO token exists in URL but verification API is still running
  if (this.ssoToken && !this.isSsoVerified && this.isLoading) {
    // Keep loader spinning until verification completes, then trigger order
    return;
  }

  // If SSO token is verified, skip login/OTP step completely
  if (this.isSsoVerified && this.token) {
    alert(this.token)
    alert(this.isSsoVerified);
    this.generatePaymentOrder(this.token);
  } else {
    this.popupStep = 1;
  }
}

  closePopup() { 
    this.showPopup = false; 
    this.backendOrderId = '';
    this.isLoading = false;
    
    // Clear user data only if operating in direct access (non-SSO) mode
    if (!this.isSsoVerified) {
      this.userData = { name: '', phone: '', otp: '' };
    }
  }

  onlyNumbersAllowed(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // ================= UNIFIED STEP CONTROL =================
  nextStep() {
    // STEP 1: Handle Login / Request OTP Delivery (Direct Flow)
    if (this.popupStep === 1) {
      const cleanPhoneStr = this.userData.phone ? this.userData.phone.toString().trim() : '';

      if (!cleanPhoneStr || cleanPhoneStr.length !== 10) {
        alert('Please enter a valid 10-digit mobile number');
        return;
      }
      
      const phoneNo = Number(cleanPhoneStr);
      if (isNaN(phoneNo)) {
        alert('Mobile number must contain digits only');
        return;
      }
      
      const patientName = this.userData.name || '.';
      this.isLoading = true;

      this.authService.subscriptionLoginOtp(phoneNo, patientName).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          console.log('OTP Sent Successfully', response);
          this.popupStep = 2;
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Login Error', err);
          alert(err.error?.message || 'Something went wrong. Please try again.');
        }
      });
    } 
    
    // STEP 2: Validate OTP & Obtain Patient Token (Direct Flow)
    else if (this.popupStep === 2) {
      const cleanOtpStr = this.userData.otp ? this.userData.otp.toString().trim() : '';

      if (!cleanOtpStr || cleanOtpStr.length !== 4) {
        alert('Please enter the complete 4-digit OTP code');
        return;
      }

      const otpNumber = Number(cleanOtpStr);
      const phoneNo = Number(this.userData.phone);
      const patientName = this.userData.name || '.';

      if (isNaN(otpNumber)) {
        alert('OTP must contain numbers only');
        return;
      }

      this.isLoading = true;

      this.authService.authenticateOTP(otpNumber, phoneNo, patientName).subscribe({
        next: (response: any) => {
          console.log('OTP Verified Successfully!', response);
          let token = response.token || response.response.token;
          console.log("token1",token);
          this.generatePaymentOrder(token);
        },
        error: (err) => {
          this.isLoading = false;
          console.error('OTP Verification Failure', err);
          alert(err.error?.message || 'Invalid verification code. Please check and try again.');
        }
      });
    }
    
    else if (this.popupStep < 4) {
      this.popupStep++;
    }
  }

  // ================= SECURE BACKEND INTERFACE ROUTE =================
  generatePaymentOrder(token: any) {
    this.isLoading = true;
    console.log("token",token);
    
    this.token = token;
    alert(this.selectedPlan.duration);
    const orderPayload = {
      duration: this.selectedPlan.duration,
      phone: this.userData.phone,
      name: this.userData.name || '.',
      token: this.token
    };
    alert(`
User Details:
• Duration: ${this.selectedPlan.duration}
• Phone: ${this.userData.phone}
• Name: ${this.userData.name}
• Token: ${this.token}
`);
    this.authService.patientSubscriptionOrderCreate(orderPayload).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response && response.orderId) {
          this.backendOrderId = response.orderId;
          this.popupStep = 3; // Shift directly to Confirm & Activate Screen
        } else {
          alert('Failed to get a valid transactional token context from the server.');
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Order Creation Error', err);
        alert(err.error?.message || 'Error initializing secure payment order.');
      }
    });
  }

  // ================= STEP 3: NATIVE CHECKOUT GATEWAY TRIGGER =================
  payWithRazorpay() {
    if (!this.backendOrderId) {
      alert('Transaction context missing or expired. Please verify your credentials again.');
      this.popupStep = 1;
      return;
    }

    const options = {
      key: environment.razorpayKeyId, 
      amount: this.selectedPlan.price * 100,
      currency: 'INR',
      name: 'DOQMA',
      description: `Purchase: ${this.selectedPlan.name}`,
      image: '../../../assets/logo.png', 
      order_id: this.backendOrderId,
      prefill: {
        name: this.userData.name,
        contact: this.userData.phone
      },
      theme: {
        color: '#5bc5c5' 
      },
      handler: (response: any) => {
        this.handlePaymentSuccess(response);
      },
      modal: {
        ondismiss: () => {
          console.log('Payment modal exited prematurely by user action.');
        }
      }
    };

    const rzp = new Razorpay(options);
    rzp.open();
  }

  // ================= STEP 4: SUCCESS SUMMARY DRAWER =================
  // handlePaymentSuccess(paymentMetadata: any) {
  //   this.isLoading = true;
    
  //   const verificationPayload = {
  //     razorpayOrderId: paymentMetadata.razorpay_order_id,
  //     razorpayPaymentId: paymentMetadata.razorpay_payment_id,
  //     razorpaySignature: paymentMetadata.razorpay_signature,
  //     // duration: this.selectedPlan.duration,
  //     // phone: this.userData.phone,
  //     token: this.token
  //   };

  //   console.log("HANDLE SUCCESS", verificationPayload);
  //   this.authService.subscriptionverification(verificationPayload).subscribe({
  //     next:(response:any)=>{
  //       this.finalSuccessLoading = true;

  //     },
  //     error: (err)=>{
  //       this.finalSuccessLoading = false;
  //     }

  //   })

  //   // this.authService.verifySubscriptionPayment(verificationPayload).subscribe({
  //   //   next: (serverVerificationResponse: any) => {
  //   //     this.ngZone.run(() => {
  //   //       this.isLoading = false;
  //   //       this.popupStep = 4;
  //   //       console.log('Subscription fully activated on server:', serverVerificationResponse);
  //   //     });
  //   //   },
  //   //   error: (err: any) => {
  //   //     this.isLoading = false;
  //   //     console.error('Payment Verification Failed inside backend context:', err);
  //   //     alert(err.error?.message || 'Payment received, but verification failed. Please contact support.');
  //   //   }
  //   // });
  // }


handlePaymentSuccess(paymentMetadata: any) {
  this.isLoading = true;

  this.pollForActivation(paymentMetadata.razorpay_order_id).subscribe({
    next: (response: any) => {
      this.ngZone.run(() => {
        this.isLoading = false;
        this.finalSuccessLoading = true;
        this.popupStep = 4;
        console.log('Subscription activated:', response);
      });
    },
    error: (err: any) => {
      this.ngZone.run(() => {
        this.isLoading = false;
        console.error('Activation check failed:', err);
        this.onActivationFailed();
      });
    }
  });
}

private pollForActivation(orderId: string) {
  return timer(0, 2000).pipe(
    switchMap(() =>
      this.authService.getSubscriptionStatus(orderId, this.token).pipe(
        catchError(() => of({ status: 'PENDING' }))
      )
    ),
    filter((res: any) => res.status !== 'PENDING'),
    take(1),
    timeout(30000), // give the webhook ~30s
    map((res: any) => {
      if (res.status === 'COMPLETED') return res;
      throw new Error(res.status); // FAILED / REFUNDED -> goes to error()
    })
  );
}

private onActivationFailed() {
  alert(
    'Payment received but activation is taking longer than usual. ' +
    'Please check "My Plans" in a few minutes, or contact support if it doesn\'t appear.'
  );
  this.popupStep = 1;
}


openApp() {
  const packageId = 'com.paspatient';
  const playStoreUrl = `https://play.google.com/store/apps/details?id=${packageId}&pcampaignid=web_share`;

  const isAndroid = /android/i.test(navigator.userAgent);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  if (isAndroid) {
    // Chrome resolves this: if the app is installed, it opens directly;
    // if not, it falls back to the Play Store URL automatically.
    const intentUrl = `intent://open#Intent;package=${packageId};scheme=https;S.browser_fallback_url=${encodeURIComponent(playStoreUrl)};end`;
    window.location.href = intentUrl;
  } else if (isIOS) {
    // No iOS app store link given yet — falls back to the Play Store link,
    // which won't help an iPhone user. Replace with the App Store URL once you have it.
    window.location.href = playStoreUrl;
  } else {
    // Desktop: nothing to "open" — just send them to the store page
    window.open(playStoreUrl, '_blank');
  }

  this.closePopup();
}
}